import { Expose } from 'class-transformer'

export class RegisterResponseType {
  @Expose()
  id: number

  @Expose()
  email: string

  @Expose()
  displayName: string
}
